import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { REPORT_URL } from '../../utils/urls';
import instance from '../../services/services';
import PopupLoginError from './LoginError';

function ReportPopup ({ isPopup, setIsPopup, order_seq }){
  const selectRef = useRef();
  const location = useLocation();
  const [popupActive, setPopupActive] = useState(false);
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);


  const [state, setState] = useState({
    isReason: false,
  });

  const [formData, setFormData] = useState({
    return_memo: '',
  });
  
  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);
  };
  
  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };

  const selectList = [
    { value: '1', name: '불친절' },
    { value: '2', name: '장비누락' },
    { value: '3', name: '장비고장' },
    { value: '4', name: '기타' },
];
  

  // 사유 셀렉박스
  const handleSelectOpen = () => {
    setState(prev => ({ 
      ...prev, 
      isReason: !prev.isReason,
    }));
  };

  // 사유 셀렉박스 선택 핸들러
  const handleSelectedItem = (select) => {
    setState(prev => ({
      ...prev,
      isReason: false,
      selectValue: select.value,
      selectedName: select.name // 선택된 이름 저장
    }));
  };

  // 외부 클릭시, 셀렉박스 닫힘
  useEffect(() => {
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setState(prev => ({ ...prev, isReason: false }));
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleReport = async () => {
    try {
      const response = await instance.post(REPORT_URL, {
        order_seq: order_seq,
        report_type: state.selectValue,
        report_content: formData.return_memo,
      });
      if (response.status === 200) {
        setIsPopupLoginError({
          message: "신고가 완료되었습니다.",
          action: 'reload'
        });
      }
    } catch (error) {
      console.error('신고 처리 중 오류 발생:', error);
      setIsPopupLoginError({
        message: error.response?.data?.message || "신고 제출에 실패했습니다.",
        action: 'reload'
      });
    }
  } 

  const resetStates = () => {
    setIsPopupLoginError({
      message: '',
      action: ''
    });
  };

  const handleConfirm = () => {
    resetStates();
    setIsPopup(false);
    if (isPopupLoginError.action === 'reload') {
      window.location.reload();
    }
  };
  

  if (isPopup)
    return (
        <div 
          className="popup-box-component"
          onClick={handleBackgroundClick}
        >
          <div className={`box content s ${popupActive ? 'active' : ''}`}>
            <div className="popup_container">
              <h4 className='pop_title line'>신고하기</h4>
              <div className='close_btn_con'>
                <button 
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>

              <div className='p3_box'>
                <h3 className='p3'>불편하셨던 점을 알려주세요!</h3>
                <p className='g-90 b1_2'>
                서비스 이용 중 불편함을 느끼신 점에 대해 귀중한 의견을 남겨주시면 감사하겠습니다. 회원님의 소중한 피드백을 바탕으로 더욱 만족스러운 경험을 제공하기 위해 최선을 다하겠습니다.
                </p>
              </div>

              <div className='column flex-8 report_box'>
                <div
                  ref={selectRef}
                  className={`default_select border ${state.isReason ? 'open' : ''}`}
                >
                  <button
                    type="button"
                    className={`select_btn ${state.selectValue ? 'active' : ''}`}
                    onClick={handleSelectOpen}
                  >
                    <span className="ellipsis_clamp">
                      {state.selectedName || '신고 사유 선택'}
                    </span>
                  </button>
                  <ul className="select_list">
                    {selectList.map(select => (
                      <li
                        key={select.value}
                        className={`select_item ellipsis1 ${
                          state.selectValue === select.value ? 'active' : ''
                        }`}
                        onClick={() => handleSelectedItem( select)}
                      >
                        {select.name}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="default_input">
                    <textarea
                      value={formData.return_memo}
                      onChange={(e) =>
                        setFormData(prev => ({
                          ...prev,
                          return_memo: e.target.value
                        }))
                      }
                      placeholder="(필수) 신고 내용을 100자 이내로 작성해 주세요."
                    />
                  </div>
              </div>

              <div className='pop_btn_wrap'>
                <button 
                  type="button"
                  className="default_btn black pop_con_btn" 
                  onClick={handleReport}
                >
                  신고하기
                </button>
              </div>
            </div>
          </div>
          <PopupLoginError 
            isPopup={isPopupLoginError} 
            setIsPopup={setIsPopupLoginError}
            onConfirm={handleConfirm}
          />
        </div>
    );
};

export default ReportPopup ;